import {api} from '@/http'

// 绩效填报添加
const addFillCoefficient = (data, callback, back) => {
  api('/api/JX_CQ/Insert', 'post', data, callback, back)
}

// 绩效填报-参与项目列表
const getXMList = (callback, back) => {
  api('/api/JX_CQ/XMList', 'post', {}, callback, back)
}

// 绩效填报-参与项目内容列表
const getNRList = (callback, back) => {
  api('/api/JX_CQ/NRList', 'post', {}, callback, back)
}

export default {
  addFillCoefficient,
  getXMList,
  getNRList
}



// WEBPACK FOOTER //
// ./src/api/fill/index.js